// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FeatureMenu_wrapper__gGknD","item-wrapper":"FeatureMenu_item-wrapper__kGWIi","item-cat":"FeatureMenu_item-cat__u80jq","item":"FeatureMenu_item__diEN4"};